import { z } from 'zod';
/**
 * Severity, aligned to what a DAST tool reports rather than to a bespoke scale.
 *
 * `INFORMATIONAL` is kept because ZAP emits a great deal of it and dropping it at ingest
 * would lose the record of what was looked at.
 */
export const SeveritySchema = z.enum(['CRITICAL', 'HIGH', 'MEDIUM', 'LOW', 'INFORMATIONAL']);
/**
 * How much the system believes its own finding.
 *
 * `UNVERIFIED` is the default at ingest: a scanner alert is a hypothesis until something
 * reproduces it. §1 — "a finding without a reproducible request/response is a hypothesis".
 */
export const FindingStatusSchema = z.enum([
    'UNVERIFIED',
    'CONFIRMED',
    'FALSE_POSITIVE',
    'ACCEPTED_RISK',
    'FIXED',
]);
/**
 * What a finding is evidenced by.
 *
 * The request and response are stored in S3, not in DynamoDB: they can be large, they are
 * target-controlled content, and keeping them out of the item means a finding can be listed
 * without ever loading untrusted bytes (§4).
 */
export const EvidenceSchema = z.object({
    /** S3 key of the captured request/response pair. Absent until a scan produces one. */
    s3Key: z.string().min(1).optional(),
    method: z.string().max(10).optional(),
    url: z.string().max(2048).optional(),
    /** Short excerpt shown in the console. Truncated at ingest; never the whole body. */
    excerpt: z.string().max(2000).optional(),
});
//# sourceMappingURL=finding.js.map